import React from 'react'
import Title from '../components/Title'
import Container from '../components/Container'

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import Box from '../components/Box';
import IconButton from '../components/IconButton';

const PricesData = [
    {
        "name": "Lock Installation & Repair",
        "price": "CHF 99",
        "details": [
            "Based on the type of lock and complexity of the installation or repair.",
            "Includes high-quality locks and professional installation."
        ]
    },
    {
        "name": "Emergency Lockout Service",
        "price": "CHF 149 - CHF 249",
        "details": [
            "Includes on-site arrival, unlocking, and rekeying if necessary.",
            "Available 24/7, no extra charges for after-hours service."
        ]
    },
    {
        "name": "Key Duplication",
        "price": "CHF 10 - CHF 25",
        "details": [
            "Fast, efficient key duplication for all standard home, office, and car keys."
        ]
    },
    {
        "name": "Security System Upgrade",
        "price": "CHF 199 - CHF 499",
        "details": [
            "Upgrade your home or business security with state-of-the-art locks and systems.",
            "Includes consultation and installation."
        ]
    }
]

function Prices() {
    return (
        <>
            <Container>
                <div className='flex flex-col gap-5'>
                    <Title className='text-center !text-black'>
                        Transparent Pricing
                    </Title>
                    <div className='text-center text-base md:text-xl'>
                        We believe in honesty and transparency. Our pricing is straightforward with no hidden fees or unexpected charges. Whether you need an emergency lockout service or a security system installation, we offer fixed price guarantees so you know exactly what to expect.
                    </div>

                </div>
            </Container>
            <Swiper
                spaceBetween={25}
                centerInsufficientSlides={true}
                breakpoints={{
                    0: {
                        slidesPerView: 1.1,
                    },
                    600: {
                        slidesPerView: 2.1,
                    },
                    900: {
                        slidesPerView: 2.7,
                    },
                    1100: {
                        slidesPerView: 3.2,
                    },
                    1350: {
                        slidesPerView: 4.1,
                    },
                    1600: {
                        slidesPerView: 5,
                    }
                }}
                className='!pt-10 !pb-5 !px-4 max-w-[1700px] mx-auto'
            >
                {PricesData.map((data, index) => (
                    <SwiperSlide>
                        <Box className='!min-h-[400px] flex items-stretch'>
                            <div className='flex flex-col gap-4'>
                                <div className='text-xl font-medium text-[#111D15] text-center'>
                                    {data.name}
                                </div>
                                <div className=' text-primary font-bold text-3xl text-center'>
                                    {data.price}
                                </div>
                                {data.details.map((detail) => (
                                    <div className='text-[#666666] flex gap-2 leading-[35px]'>
                                        <div className=''>
                                            •
                                        </div>
                                        <div>
                                            {detail}
                                        </div>
                                    </div>
                                ))}

                                <a href="#contact-us" className='mt-auto block'>

                                    <IconButton className={'w-full'}>
                                        Request Service
                                    </IconButton>
                                </a>
                            </div>
                        </Box>

                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    )
}

export default Prices